import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';
export const deleteCityFunc = createAsyncThunk(
    "deleteCity",
    async (id, thunkAPI) => {
        try {
            const response = await api.delete(`dashboard/cities/${id}`);
            return response.data;
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
)

const deleteCitySlicer = createSlice({
    name: "deleteCity",
    initialState: {
        loading: false,
        data: [],
        error: null,
        apiErrors: {},
        successMessage: "",
    },
    reducer: {},
    extraReducers: (builder) => {
        builder.addCase(deleteCityFunc.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.apiErrors = {};
        })
            .addCase(deleteCityFunc.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.successMessage = action.payload?.message || "";

            })
            .addCase(deleteCityFunc.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.apiErrors = action.payload?.errors || {};
            });
    }
})

export default deleteCitySlicer.reducer;